import styled, { keyframes } from "styled-components";

import { pageRoot } from "../../styles/pageRoot";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  ${pageRoot}
  background-color: var(--color-background, #f4f7fa);
`;

export const Main = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3.2rem 2.4rem;
  animation: ${fadeIn} 0.6s ease-out forwards;

  .error-card {
    background: #ffffff;
    border-radius: 1.6rem;
    padding: 3.2rem;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.03);
    width: 100%;
    max-width: 500px;
  }
`;
